import React from 'react';
import ConfirmationCard from '../ConfirmationCards';

const ConfirmationEmails: React.FC<{
  emails: GQL.IEmailConfirmation[];
  selectedId:  string | number | null;
  setSelectedId: React.Dispatch<React.SetStateAction< string | number | null>>;
}> = ({ emails, selectedId, setSelectedId }) => {
  return (
    <div>
      {emails.map((email) => (
        <ConfirmationCard
          contentCardText={email.enderecoEmail!}
          setOption={setSelectedId}
          id={email.codigoEmail!}
          selectedId={selectedId}
        />
      ))}
    </div>
  );
};

export default ConfirmationEmails;
